import React from 'react'
import Modal from 'react-modal'
import _get from 'lodash/get'
import modalStyle from '../../../../_common/core/modalStyle'
import AddOnForm from '../../addons/AddOnForm'

const ADD_ON_MODAL_ID = 'add_on_form_modal'

const AddOnModal = props => {
  const {
    user,
    event,
    tickets,
    isEditing,
    initialValues,
    handleSubmitEditAddon,
    handleSubmitEditAddonGroup,
    handleCancelAddon,
    tables,
    enableAddOnsWithVariants,
    configs,
    isAddOnGroupSelected,
    stockLabel,
  } = props

  return (
    <Modal
      className="modal-dialog modal-trans"
      style={{
        overlay: { ...modalStyle.overlay, zIndex: 10002 },
        content: { ...modalStyle.content },
      }}
      isOpen={isEditing}
      contentLabel="Modal"
      onRequestClose={handleCancelAddon}
      closeTimeoutMS={150}
      ariaHideApp={false}
      overlayRef={ref => {
        if (ref) {
          ref.setAttribute('id', ADD_ON_MODAL_ID)
        }
      }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div>Edit Add-On</div>
          </div>
          <AddOnForm
            user={user}
            event={event}
            tables={tables}
            tickets={tickets}
            isEditing={isEditing}
            initialValues={initialValues}
            isAddOnGroupSelected={isAddOnGroupSelected}
            handleSubmit={handleSubmitEditAddon}
            handleSubmitGroup={handleSubmitEditAddonGroup}
            onCancel={handleCancelAddon}
            enableAddOnsWithVariants={enableAddOnsWithVariants}
            configs={_get(configs, 'children.AddOnForm')}
            stockLabel={stockLabel}
            containerId={ADD_ON_MODAL_ID}
          />
        </div>
      </div>
    </Modal>
  )
}

export default AddOnModal
